import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Session } from '../services/session';

interface IComplianceHubRedirectGuardConfig {
  value: boolean;
  replacePathWith: string;
  replaceFirstMatchOnly?: boolean;
}

@Injectable()
export class ComplianceHubRedirectGuard {
  constructor(private router: Router, private session: Session) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const urlTree: UrlTree = this.router.parseUrl(state.url);
    const urlSegments: UrlSegment[] = urlTree.root.children.primary.segments || [];
    const routeConfig: IComplianceHubRedirectGuardConfig = route.data.complianceHubRedirectGuard;

    const findAndReplaceFirstMatchOnly: (segments: UrlSegment[], replaceWith: string) => Params | string =
      (segments: UrlSegment[], replaceWith: string): Params | string => {
        const index: number = segments.findIndex((segment: UrlSegment) => segment.path === route.routeConfig.path);
        if (index >= 0) segments[index].path = replaceWith;
        return segments.map(segment => segment.path).join('/');
      }
    ;

    const redirectUrlArray = routeConfig.replaceFirstMatchOnly ?
    [findAndReplaceFirstMatchOnly(urlSegments, routeConfig.replacePathWith)] :
    [urlSegments
      // replace the existing url with redirectPath
    .map((urlSegment: UrlSegment) => {
      return urlSegment.path === route.routeConfig.path ? routeConfig.replacePathWith : urlSegment.path;
    })
    .join('/')];

    if (urlSegments.length > 0) {
      const params: Params = urlSegments[urlSegments.length - 1].parameters || {};
      redirectUrlArray.push(params);
    }

    if (urlSegments[0].path === 'overview') {
      if (this.session.isOldOverviewEnabled()) return true;
      else {
        if (this.session.isComplianceHubEnabled()) {
          this.router.navigate(redirectUrlArray);
          return false;
        }
        else {
          this.router.navigate(['/']);
          return false;
        }
      }
    }

    if (this.session.isComplianceHubEnabled() === routeConfig.value) return true;
    this.router.navigate(redirectUrlArray);
    return false;
  }
}
